export const AppSettingsEndpoints = Object.freeze({
  SystemSettings: '/v3/system/settings'
})
